import {createSlice} from "@reduxjs/toolkit";

const initialBusinessesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  businessForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const businessesSlice = createSlice({
  name: "businesses",
  initialState: initialBusinessesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getBusinessById
    businessFetched: (state, action) => {
      state.actionsLoading = false;
      state.businessForEdit = action.payload.businessForEdit;
      state.error = null;
    },
    // findBusinesses
    businessesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createBusiness
    businessCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.business);
    },
    // updateBusiness
    businessUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.business.id) {
          return action.payload.business;
        }
        return entity;
      });
    },
    // deleteBusiness
    businessDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteBusinesses
    businessesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // businessesUpdateState
    businessesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    // fetchMyBusinesses
    myBusinessesFetched: (state, action) => {
      const { totalCount, entities, individual_applications } = action.payload;
      state.listLoading = false;
      state.actionsLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.individualApplications = individual_applications;
    },
  }
});
